import Index from 'fastboot-admin/src/views/common/Index.vue'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "views" */ '../views/Login'),
    },
    {
        path: '/',
        name: 'index',
        meta: {tab: false},
        component: Index,
        children:[
            {
                path: '/update-user-info',
                name: 'update-user-info',
                meta: {title: 'Update User Info', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/UpdateUserInfo'),
            },
            {
                path: '/update-user-password',
                name: 'update-user-password',
                meta: {title: 'Update User Password', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/UpdateUserPassword'),
            },
            {
                path: '/check-in-record/list',
                name: 'check-in-record-list',
                meta: {title: 'Check in record', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/check-in-record/List'),
            },
            {
                path: '/check-in-record/add',
                name: 'check-in-record-add',
                meta: {title: 'Add check in record', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/check-in-record/Add'),
            },
            {
                path: '/check-in-record/edit',
                name: 'check-in-record-edit',
                meta: {title: 'Edit check in record', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/check-in-record/Edit'),
            },
            {
                path: '/room-setting',
                name: 'room-setting',
                meta: {title: 'Room Setting', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/dict-manager/Edit'),
            },
            {
                path: '/sys-config',
                name: 'sys-config',
                meta: {title: 'Sys Config', tab: true},
                component: () => import(/* webpackChunkName: "views" */ '../views/SysConfig'),
            }
        ]
    }
]
;
